export default "__VITE_ASSET__CEuWBOvM__"